// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"13107456","921":"eceebd33"}[chunkId] + ".chunk.js";
};